// Density units with conversion factors to kilogram per cubic meter (kg/m³)
export const densityUnits = [
  { id: 'kilogram-per-cubic-meter', name: 'Kilogram/Cubic Meter', symbol: 'kg/m³', plural: 'Kilograms/Cubic Meter', factor: 1 },
  { id: 'gram-per-cubic-centimeter', name: 'Gram/Cubic Centimeter', symbol: 'g/cm³', plural: 'Grams/Cubic Centimeter', factor: 1000 },
  { id: 'kilogram-per-cubic-centimeter', name: 'Kilogram/Cubic Centimeter', symbol: 'kg/cm³', plural: 'Kilograms/Cubic Centimeter', factor: 1000000 },
  { id: 'gram-per-cubic-meter', name: 'Gram/Cubic Meter', symbol: 'g/m³', plural: 'Grams/Cubic Meter', factor: 0.001 },
  { id: 'gram-per-cubic-millimeter', name: 'Gram/Cubic Millimeter', symbol: 'g/mm³', plural: 'Grams/Cubic Millimeter', factor: 1000000 },
  { id: 'milligram-per-cubic-meter', name: 'Milligram/Cubic Meter', symbol: 'mg/m³', plural: 'Milligrams/Cubic Meter', factor: 0.000001 },
  { id: 'milligram-per-cubic-centimeter', name: 'Milligram/Cubic Centimeter', symbol: 'mg/cm³', plural: 'Milligrams/Cubic Centimeter', factor: 1 },
  { id: 'milligram-per-cubic-millimeter', name: 'Milligram/Cubic Millimeter', symbol: 'mg/mm³', plural: 'Milligrams/Cubic Millimeter', factor: 1000 },
  { id: 'kilogram-per-liter', name: 'Kilogram/Liter', symbol: 'kg/L', plural: 'Kilograms/Liter', factor: 1000 },
  { id: 'gram-per-liter', name: 'Gram/Liter', symbol: 'g/L', plural: 'Grams/Liter', factor: 1 },
  { id: 'gram-per-milliliter', name: 'Gram/Milliliter', symbol: 'g/mL', plural: 'Grams/Milliliter', factor: 1000 },
  { id: 'milligram-per-liter', name: 'Milligram/Liter', symbol: 'mg/L', plural: 'Milligrams/Liter', factor: 0.001 },
  { id: 'pound-per-cubic-foot', name: 'Pound/Cubic Foot', symbol: 'lb/ft³', plural: 'Pounds/Cubic Foot', factor: 16.01846337 },
  { id: 'pound-per-cubic-inch', name: 'Pound/Cubic Inch', symbol: 'lb/in³', plural: 'Pounds/Cubic Inch', factor: 27679.90471 },
  { id: 'pound-per-cubic-yard', name: 'Pound/Cubic Yard', symbol: 'lb/yd³', plural: 'Pounds/Cubic Yard', factor: 0.5932764213 },
  { id: 'pound-per-gallon-us', name: 'Pound/Gallon (US)', symbol: 'lb/gal', plural: 'Pounds/Gallon (US)', factor: 119.8264273 },
  { id: 'pound-per-gallon-uk', name: 'Pound/Gallon (UK)', symbol: 'lb/gal', plural: 'Pounds/Gallon (UK)', factor: 99.77637266 },
  { id: 'ounce-per-cubic-foot', name: 'Ounce/Cubic Foot', symbol: 'oz/ft³', plural: 'Ounces/Cubic Foot', factor: 1.001153961 },
  { id: 'ounce-per-cubic-inch', name: 'Ounce/Cubic Inch', symbol: 'oz/in³', plural: 'Ounces/Cubic Inch', factor: 1729.994044 },
  { id: 'ounce-per-gallon-us', name: 'Ounce/Gallon (US)', symbol: 'oz/gal', plural: 'Ounces/Gallon (US)', factor: 7.489151707 },
  { id: 'ounce-per-gallon-uk', name: 'Ounce/Gallon (UK)', symbol: 'oz/gal', plural: 'Ounces/Gallon (UK)', factor: 6.236023291 },
  { id: 'ton-per-cubic-yard', name: 'Ton/Cubic Yard', symbol: 'ton/yd³', plural: 'Tons/Cubic Yard', factor: 1186.552843 },
  { id: 'ton-per-cubic-meter', name: 'Ton/Cubic Meter', symbol: 't/m³', plural: 'Tons/Cubic Meter', factor: 1000 },
];

export const popularDensityConversions = [
  { from: 'kilogram-per-cubic-meter', to: 'gram-per-cubic-centimeter' },
  { from: 'gram-per-cubic-centimeter', to: 'kilogram-per-cubic-meter' },
  { from: 'kilogram-per-cubic-meter', to: 'pound-per-cubic-foot' },
  { from: 'pound-per-cubic-foot', to: 'kilogram-per-cubic-meter' },
  { from: 'gram-per-liter', to: 'kilogram-per-cubic-meter' },
  { from: 'kilogram-per-liter', to: 'gram-per-cubic-centimeter' },
  { from: 'pound-per-cubic-inch', to: 'gram-per-cubic-centimeter' },
  { from: 'gram-per-milliliter', to: 'kilogram-per-liter' },
  { from: 'pound-per-gallon-us', to: 'kilogram-per-liter' },
  { from: 'kilogram-per-cubic-meter', to: 'milligram-per-liter' },
];

export const getUnitById = (id) => densityUnits.find(unit => unit.id === id);

export const convertDensity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert ${fromUnit.plural.toLowerCase()} (${fromUnit.symbol}) to ${toUnit.plural.toLowerCase()} (${toUnit.symbol}) and learn the conversion formula.`;
};
